































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { RoutesList } from "@/router.ts"
import UsuarioService from "@/services/usuario.service";

@Component({
})
export default class UserConfig extends Vue {
  userService = new UsuarioService();
  loadingChangePasswordSave = false;
  showChangePassword = false;

  changePasswordModel: any = {
    actualPassword: "",
    newPassword: "",
    userID: 0
  };

  get user() {
    return this.$store.state.user;
  }
  
  get currentSection() {
    return this.$store.state.menuSelected;
  }

  get activeSectionMenu() {
    var activeItems:any[] = [];
    return activeItems;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  constructor() {
    super();
  }

  cancelarChangePass() {
    this.showChangePassword = false;
    this.changePasswordModel = {
      actualPassword: "",
      newPassword: "",
      userID: 0
    };
  }
  changePassword() {
    var userID = this.$store.state.user.id;
    this.changePasswordModel.userID = userID;
    this.loadingChangePasswordSave = true;
    this.userService
      .updateUserPassword(this.changePasswordModel)
      .then((usuario: any)=> {
        this.$buefy.toast.open({
          message: "Los cambios se han aplicado correctamente!",
          type: "is-success"
        });
        this.cancelarChangePass();
      })
      .catch((ex: any) => {
        let exepction = ex.response.data[0];
        if (exepction && exepction.code == "PasswordMismatch") {
          this.$buefy.toast.open({
            message: "Contraseña incorrecta!",
            type: "is-danger"
          });
        }
      })
      .finally(() => {
        this.loadingChangePasswordSave = false;
      });
  }
}
